import { ReactNode } from 'react'

interface InfoRowProps {
  label: ReactNode
  value: ReactNode
  action?: ReactNode
}

export const InfoRow = ({ label, value, action }: InfoRowProps) => (
  <div className="flex items-center justify-between gap-3">
    <span className="text-text-tertiary shrink-0">{label}</span>
    <span className="flex min-w-0 items-center gap-1">
      <span
        className="text-text-primary min-w-0 truncate text-right"
        title={typeof value === 'string' ? value : undefined}
      >
        {value}
      </span>
      {action && <span className="inline-flex size-4 shrink-0">{action}</span>}
    </span>
  </div>
)
